import { render, staticRenderFns } from "./CoreTableCell.vue?vue&type=template&id=33fc08aa&lang=pug&"
import script from "./CoreTableCell.vue?vue&type=script&lang=js&"
export * from "./CoreTableCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports